export default __webpack_public_path__ + "static/media/hero-services.a53d13a2.jpg";